module.exports = __webpack_public_path__ + "img/bg1.31fb58cf.jpg";